package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_01_20_Day_1
import com.veldekar.components.logs.Log_2023_01_20_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-01-20")
@Composable
public fun Log_2023_01_20(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "The Investigation Begins",
        ogTitle = "The Investigation Begins",
        date = LocalDate(2_023, 1, 20),
        ogDescription = "The party investigates the Crond brothers' home and searches for missing guards near a mysterious ridge.",
        ogImage = "ai/2023-01-20.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-9", dateString = "Newgrowth 9")
        Log_2023_01_20_Day_1()
        SessionDayHeader(dayId = "newgrowth-10", dateString = "Newgrowth 10")
        Log_2023_01_20_Day_2()
    }
}
